/*@ngInject*/
const DynamicDataRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFilter = function (dataName, filterType, context) {
        let url = '/rest/DynamicData/' + dataName + '/filter/type/' + filterType,
            params = {
            };
        return this.post(url, context, {params: params}).then(function (result) {
            return result;
        });
    };

    this.find = function (dataName, criteria, filterUri) {
        let url = '/rest/DynamicData/' + dataName + '/filter',
            config = {
                params: {
                    filterUri: filterUri
                }
            };
        return this.post(url, criteria, config).then(function (result) {
            return result;
        });
    };

    this.execute = function (dataName, actionName, target) {
        let url = '/rest/DynamicData/' + dataName + '/action/' + actionName;
        return this.post(url, target).then(function (result) {
            return result;
        });
    };
}

angular.module('gw-um-extensions')
    .service('dynamicDataRepository', DynamicDataRepository);
